import { ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import { TooltipCell } from 'pages/FundInvestments/components';
import { useWaterfallFXContext } from '../WaterfallFX/WaterfallFXContext/WaterfallFXContext';

const WaterfallUnscaledHeaderValueViewer = ({ cell }: Pick<ValueViewerProps, 'cell'>) => {
  const context = useWaterfallFXContext();

  if (!context || context.units === REGULAR_UNIT) {
    return (
      <span className="value-viewer">
        <span className="text-cell">{String(cell.value ?? '')}</span>
      </span>
    );
  }

  const label = String(cell.value ?? '');
  const { selectedCurrency } = context;
  const tooltip = selectedCurrency
    ? `Displayed in ${selectedCurrency.sourceCurrency} (${selectedCurrency.symbol}) actuals.`
    : 'Displayed in actuals.';

  return <TooltipCell compact title={label} tooltipContent={tooltip} placement="top" />;
};

export default WaterfallUnscaledHeaderValueViewer;
